import { FC } from 'react';
import { TriangleIcon } from 'assets/svg';
import * as S from './Welcome.styled';

interface IWelcomeProps {
  onStartQuiz: () => void;
}

export const Welcome: FC<IWelcomeProps> = ({ onStartQuiz }) => {
  return (
    <S.Wrapper>
      <S.BigText>
        How much do you know about digital solutions?
      </S.BigText>
      <S.SmallText>Answer a few quick questions and claim your prize!</S.SmallText>
      <S.StartButton onClick={onStartQuiz}>
        <S.ButtonText>Start quiz</S.ButtonText>
        <S.ButtonContent>
          <TriangleIcon />
          <TriangleIcon />
          <TriangleIcon />
        </S.ButtonContent>
      </S.StartButton>
    </S.Wrapper>
  );
};
